import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IState } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const ListStateSlice = createSlice({
  name: "ListStateSlice",
  initialState: {} as IReduxState<IState[]>,
  reducers: {
    listState: (state, _: PayloadAction<IState>) => {
      state.isLoading = true;
    },
    successlistState: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistState: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearListState: (state) => {
      state.data = {};
    },
  },
});

export const { failurelistState, clearListState, successlistState, listState } =
  ListStateSlice.actions;

export default ListStateSlice.reducer;
